module.exports = __webpack_public_path__ + "img/prelaunch.72968394.svg";